// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Pingflo voice caption — docks in the table-setup footer caption slot. */
.lt-pingflo-voice__portal {
  position: absolute;
  left: 8px;
  right: 8px;
  bottom: calc(52px + env(safe-area-inset-bottom, 0px));
  z-index: 40;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 6px;
  pointer-events: none;
  background: transparent;
  box-sizing: border-box;
}

.lt-pingflo-voice__portal--caption {
  position: relative;
  left: auto;
  right: auto;
  bottom: auto;
  z-index: 2;
  width: 100%;
}

.lt-pingflo-voice__portal--caption .lt-pingflo-voice__caption {
  min-height: 48px;
  border-radius: 12px;
  box-shadow: none;
  padding: 4px 6px;
}

/* When portaled outside the dialog (fallback), pin above coach bar. */
.lt-pingflo-voice__portal--viewport {
  position: fixed;
  left: 8px;
  right: 8px;
  bottom: calc(var(--lt-coach-bar-reserve, 68px) + 8px);
  z-index: 1600;
  max-width: 560px;
  margin: 0 auto;
}

.lt-pingflo-voice__caption {
  --lt-pingflo-ink: #f4f7fb;
  --lt-pingflo-muted: rgba(244, 247, 251, 0.7);
  --lt-pingflo-surface: color-mix(in srgb, #0f172a 88%, var(--lt-brand, #0877bc));
  --lt-pingflo-border: rgba(255, 255, 255, 0.14);
  pointer-events: auto;
  display: grid;
  grid-template-columns: 32px minmax(0, 1fr) 40px 40px 32px;
  align-items: center;
  gap: 4px;
  min-height: 48px;
  padding: 5px 6px;
  border-radius: 14px;
  border: 1px solid var(--lt-pingflo-border);
  background: var(--lt-pingflo-surface);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.28);
  color: var(--lt-pingflo-ink);
  box-sizing: border-box;
}

.lt-pingflo-voice__caption.is-listening {
  border-color: rgba(248, 113, 113, 0.65);
  box-shadow:
    0 8px 20px rgba(0, 0, 0, 0.28),
    0 0 0 1px rgba(248, 113, 113, 0.25);
}

.lt-pingflo-voice__caption.is-editing {
  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 65%, #fff);
}

.lt-pingflo-voice__mark {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.lt-pingflo-voice__field-wrap {
  position: relative;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.lt-pingflo-voice__status {
  margin: 0;
  font-size: 0.58rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: var(--lt-pingflo-muted);
  line-height: 1.1;
  display: inline-flex;
  align-items: center;
  gap: 3px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.lt-pingflo-voice__status.is-live {
  color: #fecaca;
}

.lt-pingflo-voice__status svg {
  font-size: 0.8rem !important;
}

.lt-pingflo-voice__input {
  width: 100%;
  min-height: 24px;
  max-height: 48px;
  resize: none;
  border: none;
  outline: none;
  background: transparent;
  color: var(--lt-pingflo-ink);
  font: inherit;
  font-size: 0.86rem;
  font-weight: 650;
  line-height: 1.25;
  letter-spacing: -0.01em;
  padding: 0;
  box-sizing: border-box;
}

.lt-pingflo-voice__input::placeholder {
  color: color-mix(in srgb, var(--lt-pingflo-ink) 40%, transparent);
  font-weight: 500;
}

.lt-pingflo-voice__input:disabled {
  opacity: 0.65;
}

.lt-pingflo-voice__meter {
  display: none;
}

.lt-pingflo-voice__caption.is-listening .lt-pingflo-voice__meter {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  align-items: end;
  gap: 2px;
  height: 12px;
  margin-top: 2px;
}

.lt-pingflo-voice__bar {
  display: block;
  width: 100%;
  border-radius: 999px;
  background: linear-gradient(
    180deg,
    #fda4af 0%,
    color-mix(in srgb, var(--lt-brand, #0877bc) 70%, #fff) 100%
  );
  transform-origin: center bottom;
  transition: transform 80ms linear, opacity 80ms linear;
}

.lt-pingflo-voice__icon-btn {
  width: 40px;
  height: 40px;
  border-radius: 11px;
  border: 1px solid var(--lt-pingflo-border);
  background: rgba(255, 255, 255, 0.08);
  color: var(--lt-pingflo-ink);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
}

.lt-pingflo-voice__icon-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.lt-pingflo-voice__send {
  width: 40px;
  height: 40px;
  border-radius: 11px;
  border: none;
  background: var(--lt-brand, #0877bc);
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  box-shadow: 0 4px 12px color-mix(in srgb, var(--lt-brand, #0877bc) 35%, transparent);
}

.lt-pingflo-voice__send:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  box-shadow: none;
}

.lt-pingflo-voice__close {
  width: 32px;
  height: 32px;
  border-radius: 9px;
  border: 1px solid var(--lt-pingflo-border);
  background: transparent;
  color: var(--lt-pingflo-muted);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
}

.lt-pingflo-voice__close:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.lt-pingflo-voice__mic {
  justify-self: center;
}

.lt-pingflo-voice__caption .lt-pingflo-voice__mic .MuiIconButton-root {
  width: 36px !important;
  height: 36px !important;
}

.lt-pingflo-voice__banner {
  pointer-events: auto;
  margin: 0;
  padding: 6px 10px;
  border-radius: 10px;
  font-size: 0.72rem;
  font-weight: 650;
  line-height: 1.3;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(15, 23, 42, 0.92);
  color: #e2e8f0;
}

.lt-pingflo-voice__banner--error {
  border-color: rgba(248, 113, 113, 0.45);
  background: rgba(127, 29, 29, 0.88);
  color: #fecaca;
}

.lt-pingflo-voice__banner--ok {
  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 45%, #fff);
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 28%, #0f172a);
}

.lt-pingflo-voice__open-card {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 40px;
  padding: 6px 12px;
  border-radius: 12px;
  border: 1px solid color-mix(in srgb, var(--lt-brand, #0877bc) 45%, #fff);
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 16%, transparent);
  color: inherit;
  font-size: 0.82rem;
  font-weight: 700;
  cursor: pointer;
}

.lt-coach-tables-dialog__pingflo-mic.is-listening,
.lt-coach-tables-dialog__pingflo-mic.is-open {
  border-color: rgba(248, 113, 113, 0.7);
  background: rgba(220, 38, 38, 0.22);
  animation: lt-coach-recording-pulse 1.5s infinite;
}

/* Light mode */
.light-mode .lt-pingflo-voice__caption {
  --lt-pingflo-ink: #0f172a;
  --lt-pingflo-muted: #475569;
  --lt-pingflo-surface: color-mix(in srgb, var(--lt-brand, #0877bc) 8%, #ffffff);
  --lt-pingflo-border: color-mix(in srgb, var(--lt-brand, #0877bc) 28%, #cbd5e1);
  box-shadow: 0 6px 16px rgba(15, 23, 42, 0.12);
}

.light-mode .lt-pingflo-voice__caption.is-listening {
  border-color: rgba(220, 38, 38, 0.55);
}

.light-mode .lt-pingflo-voice__status.is-live {
  color: #b91c1c;
}

.light-mode .lt-pingflo-voice__icon-btn {
  background: rgba(15, 23, 42, 0.04);
}

.light-mode .lt-pingflo-voice__banner {
  background: #fff;
  border-color: #cbd5e1;
  color: #0f172a;
}

.light-mode .lt-pingflo-voice__banner--error {
  background: #fef2f2;
  border-color: #fecaca;
  color: #991b1b;
}

.light-mode .lt-pingflo-voice__banner--ok {
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 12%, #fff);
  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 35%, #cbd5e1);
  color: #0f172a;
}

.light-mode .lt-pingflo-voice__open-card {
  color: #0f172a;
  background: color-mix(in srgb, var(--lt-brand, #0877bc) 10%, #fff);
}

@media (max-width: 420px) {
  .lt-pingflo-voice__portal {
    left: 6px;
    right: 6px;
    bottom: calc(48px + env(safe-area-inset-bottom, 0px));
  }

  .lt-pingflo-voice__caption {
    grid-template-columns: 28px minmax(0, 1fr) 36px 36px 28px;
    gap: 3px;
    padding: 4px 5px;
    min-height: 44px;
  }

  .lt-pingflo-voice__input {
    font-size: 0.8rem;
  }

  .lt-pingflo-voice__icon-btn,
  .lt-pingflo-voice__send {
    width: 36px;
    height: 36px;
  }

  .lt-pingflo-voice__close {
    width: 28px;
    height: 28px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/LiveTraining/LiveTrainingTableSetupPingfloVoice.css"],"names":[],"mappings":"AAAA,0EAA0E;AAC1E;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,qDAAqD;EACrD,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,QAAQ;EACR,oBAAoB;EACpB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,sEAAsE;AACtE;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,qDAAqD;EACrD,aAAa;EACb,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,4CAA4C;EAC5C,+EAA+E;EAC/E,8CAA8C;EAC9C,oBAAoB;EACpB,aAAa;EACb,yDAAyD;EACzD,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,qCAAqC;EACrC,0CAA0C;EAC1C,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,uCAAuC;EACvC;;uCAEqC;AACvC;;AAEA;EACE,oEAAoE;AACtE;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,8BAA8B;EAC9B,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,4BAA4B;EAC5B,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,iEAAiE;EACjE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,gBAAgB;EAChB,QAAQ;EACR,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,oBAAoB;EACpB;;;;GAIC;EACD,+BAA+B;EAC/B,sDAAsD;AACxD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,qCAAqC;EACrC,4BAA4B;EAC5B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,oCAAoC;EACpC,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,UAAU;EACV,oFAAoF;AACtF;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,uBAAuB;EACvB,8BAA8B;EAC9B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,2CAA2C;EAC3C,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,oEAAoE;EACpE,qEAAqE;AACvE;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,wEAAwE;EACxE,yEAAyE;EACzE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,sCAAsC;EACtC,mCAAmC;EACnC,iDAAiD;AACnD;;AAEA,eAAe;AACf;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,8EAA8E;EAC9E,8EAA8E;EAC9E,6CAA6C;AAC/C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kEAAkE;EAClE,uEAAuE;EACvE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kEAAkE;AACpE;;AAEA;EACE;IACE,SAAS;IACT,UAAU;IACV,qDAAqD;EACvD;;EAEA;IACE,yDAAyD;IACzD,QAAQ;IACR,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":["/* Pingflo voice caption — docks in the table-setup footer caption slot. */\n.lt-pingflo-voice__portal {\n  position: absolute;\n  left: 8px;\n  right: 8px;\n  bottom: calc(52px + env(safe-area-inset-bottom, 0px));\n  z-index: 40;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 6px;\n  pointer-events: none;\n  background: transparent;\n  box-sizing: border-box;\n}\n\n.lt-pingflo-voice__portal--caption {\n  position: relative;\n  left: auto;\n  right: auto;\n  bottom: auto;\n  z-index: 2;\n  width: 100%;\n}\n\n.lt-pingflo-voice__portal--caption .lt-pingflo-voice__caption {\n  min-height: 48px;\n  border-radius: 12px;\n  box-shadow: none;\n  padding: 4px 6px;\n}\n\n/* When portaled outside the dialog (fallback), pin above coach bar. */\n.lt-pingflo-voice__portal--viewport {\n  position: fixed;\n  left: 8px;\n  right: 8px;\n  bottom: calc(var(--lt-coach-bar-reserve, 68px) + 8px);\n  z-index: 1600;\n  max-width: 560px;\n  margin: 0 auto;\n}\n\n.lt-pingflo-voice__caption {\n  --lt-pingflo-ink: #f4f7fb;\n  --lt-pingflo-muted: rgba(244, 247, 251, 0.7);\n  --lt-pingflo-surface: color-mix(in srgb, #0f172a 88%, var(--lt-brand, #0877bc));\n  --lt-pingflo-border: rgba(255, 255, 255, 0.14);\n  pointer-events: auto;\n  display: grid;\n  grid-template-columns: 32px minmax(0, 1fr) 40px 40px 32px;\n  align-items: center;\n  gap: 4px;\n  min-height: 48px;\n  padding: 5px 6px;\n  border-radius: 14px;\n  border: 1px solid var(--lt-pingflo-border);\n  background: var(--lt-pingflo-surface);\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.28);\n  color: var(--lt-pingflo-ink);\n  box-sizing: border-box;\n}\n\n.lt-pingflo-voice__caption.is-listening {\n  border-color: rgba(248, 113, 113, 0.65);\n  box-shadow:\n    0 8px 20px rgba(0, 0, 0, 0.28),\n    0 0 0 1px rgba(248, 113, 113, 0.25);\n}\n\n.lt-pingflo-voice__caption.is-editing {\n  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 65%, #fff);\n}\n\n.lt-pingflo-voice__mark {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.lt-pingflo-voice__field-wrap {\n  position: relative;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.lt-pingflo-voice__status {\n  margin: 0;\n  font-size: 0.58rem;\n  font-weight: 700;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n  color: var(--lt-pingflo-muted);\n  line-height: 1.1;\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.lt-pingflo-voice__status.is-live {\n  color: #fecaca;\n}\n\n.lt-pingflo-voice__status svg {\n  font-size: 0.8rem !important;\n}\n\n.lt-pingflo-voice__input {\n  width: 100%;\n  min-height: 24px;\n  max-height: 48px;\n  resize: none;\n  border: none;\n  outline: none;\n  background: transparent;\n  color: var(--lt-pingflo-ink);\n  font: inherit;\n  font-size: 0.86rem;\n  font-weight: 650;\n  line-height: 1.25;\n  letter-spacing: -0.01em;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n.lt-pingflo-voice__input::placeholder {\n  color: color-mix(in srgb, var(--lt-pingflo-ink) 40%, transparent);\n  font-weight: 500;\n}\n\n.lt-pingflo-voice__input:disabled {\n  opacity: 0.65;\n}\n\n.lt-pingflo-voice__meter {\n  display: none;\n}\n\n.lt-pingflo-voice__caption.is-listening .lt-pingflo-voice__meter {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  align-items: end;\n  gap: 2px;\n  height: 12px;\n  margin-top: 2px;\n}\n\n.lt-pingflo-voice__bar {\n  display: block;\n  width: 100%;\n  border-radius: 999px;\n  background: linear-gradient(\n    180deg,\n    #fda4af 0%,\n    color-mix(in srgb, var(--lt-brand, #0877bc) 70%, #fff) 100%\n  );\n  transform-origin: center bottom;\n  transition: transform 80ms linear, opacity 80ms linear;\n}\n\n.lt-pingflo-voice__icon-btn {\n  width: 40px;\n  height: 40px;\n  border-radius: 11px;\n  border: 1px solid var(--lt-pingflo-border);\n  background: rgba(255, 255, 255, 0.08);\n  color: var(--lt-pingflo-ink);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  padding: 0;\n}\n\n.lt-pingflo-voice__icon-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.lt-pingflo-voice__send {\n  width: 40px;\n  height: 40px;\n  border-radius: 11px;\n  border: none;\n  background: var(--lt-brand, #0877bc);\n  color: #fff;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  padding: 0;\n  box-shadow: 0 4px 12px color-mix(in srgb, var(--lt-brand, #0877bc) 35%, transparent);\n}\n\n.lt-pingflo-voice__send:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n.lt-pingflo-voice__close {\n  width: 32px;\n  height: 32px;\n  border-radius: 9px;\n  border: 1px solid var(--lt-pingflo-border);\n  background: transparent;\n  color: var(--lt-pingflo-muted);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  padding: 0;\n}\n\n.lt-pingflo-voice__close:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.lt-pingflo-voice__mic {\n  justify-self: center;\n}\n\n.lt-pingflo-voice__caption .lt-pingflo-voice__mic .MuiIconButton-root {\n  width: 36px !important;\n  height: 36px !important;\n}\n\n.lt-pingflo-voice__banner {\n  pointer-events: auto;\n  margin: 0;\n  padding: 6px 10px;\n  border-radius: 10px;\n  font-size: 0.72rem;\n  font-weight: 650;\n  line-height: 1.3;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  background: rgba(15, 23, 42, 0.92);\n  color: #e2e8f0;\n}\n\n.lt-pingflo-voice__banner--error {\n  border-color: rgba(248, 113, 113, 0.45);\n  background: rgba(127, 29, 29, 0.88);\n  color: #fecaca;\n}\n\n.lt-pingflo-voice__banner--ok {\n  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 45%, #fff);\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 28%, #0f172a);\n}\n\n.lt-pingflo-voice__open-card {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  min-height: 40px;\n  padding: 6px 12px;\n  border-radius: 12px;\n  border: 1px solid color-mix(in srgb, var(--lt-brand, #0877bc) 45%, #fff);\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 16%, transparent);\n  color: inherit;\n  font-size: 0.82rem;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.lt-coach-tables-dialog__pingflo-mic.is-listening,\n.lt-coach-tables-dialog__pingflo-mic.is-open {\n  border-color: rgba(248, 113, 113, 0.7);\n  background: rgba(220, 38, 38, 0.22);\n  animation: lt-coach-recording-pulse 1.5s infinite;\n}\n\n/* Light mode */\n.light-mode .lt-pingflo-voice__caption {\n  --lt-pingflo-ink: #0f172a;\n  --lt-pingflo-muted: #475569;\n  --lt-pingflo-surface: color-mix(in srgb, var(--lt-brand, #0877bc) 8%, #ffffff);\n  --lt-pingflo-border: color-mix(in srgb, var(--lt-brand, #0877bc) 28%, #cbd5e1);\n  box-shadow: 0 6px 16px rgba(15, 23, 42, 0.12);\n}\n\n.light-mode .lt-pingflo-voice__caption.is-listening {\n  border-color: rgba(220, 38, 38, 0.55);\n}\n\n.light-mode .lt-pingflo-voice__status.is-live {\n  color: #b91c1c;\n}\n\n.light-mode .lt-pingflo-voice__icon-btn {\n  background: rgba(15, 23, 42, 0.04);\n}\n\n.light-mode .lt-pingflo-voice__banner {\n  background: #fff;\n  border-color: #cbd5e1;\n  color: #0f172a;\n}\n\n.light-mode .lt-pingflo-voice__banner--error {\n  background: #fef2f2;\n  border-color: #fecaca;\n  color: #991b1b;\n}\n\n.light-mode .lt-pingflo-voice__banner--ok {\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 12%, #fff);\n  border-color: color-mix(in srgb, var(--lt-brand, #0877bc) 35%, #cbd5e1);\n  color: #0f172a;\n}\n\n.light-mode .lt-pingflo-voice__open-card {\n  color: #0f172a;\n  background: color-mix(in srgb, var(--lt-brand, #0877bc) 10%, #fff);\n}\n\n@media (max-width: 420px) {\n  .lt-pingflo-voice__portal {\n    left: 6px;\n    right: 6px;\n    bottom: calc(48px + env(safe-area-inset-bottom, 0px));\n  }\n\n  .lt-pingflo-voice__caption {\n    grid-template-columns: 28px minmax(0, 1fr) 36px 36px 28px;\n    gap: 3px;\n    padding: 4px 5px;\n    min-height: 44px;\n  }\n\n  .lt-pingflo-voice__input {\n    font-size: 0.8rem;\n  }\n\n  .lt-pingflo-voice__icon-btn,\n  .lt-pingflo-voice__send {\n    width: 36px;\n    height: 36px;\n  }\n\n  .lt-pingflo-voice__close {\n    width: 28px;\n    height: 28px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
